(() => {
  let resizeObserver, media;
  const syncHeader = () => {
    const wrapper = document.querySelector('.at-sticky-header');
    if (!wrapper) return;
    const announcement = wrapper.querySelector('.rf-announcement');
    const header = wrapper.querySelector('[data-rf-header]');
    const main = wrapper.querySelector('.rf-header-main');
    const nav = wrapper.querySelector('.rf-nav');
    if (!header || !main || !nav) return;
    const announcementHeight = announcement?.offsetHeight || 0;
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    const offset = announcementHeight + (mobile ? 0 : main.offsetHeight);
    const navOnly = !mobile && main.getBoundingClientRect().bottom <= 1;
    document.documentElement.style.setProperty('--at-announcement-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--an-sticky-offset', `${offset}px`);
    document.documentElement.style.setProperty('--at-header-height', `${Math.max(nav.offsetHeight, Math.min(header.offsetHeight, header.getBoundingClientRect().bottom))}px`);
    wrapper.classList.toggle('at-is-stuck', window.scrollY > announcementHeight);
    wrapper.classList.toggle('an-nav-only', navOnly);
    main.inert = navOnly;
  };
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {syncHeader();ticking = false;});
  }, {passive: true});
  const init = () => {
    resizeObserver?.disconnect();
    const header = document.querySelector('.at-sticky-header');
    if (header && 'ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(syncHeader);
      resizeObserver.observe(header);
    }
    syncHeader();
    media?.revert();
    if (!window.gsap || !window.ScrollTrigger) return;
    gsap.registerPlugin(ScrollTrigger);
    media = gsap.matchMedia();
    media.add({all: '(min-width: 0px)', desktop: '(min-width: 750px)', reduce: '(prefers-reduced-motion: reduce)'}, context => {
      if (context.conditions.reduce) return;
      const distance = context.conditions.desktop ? 22 : 14;
      const nodes = document.querySelectorAll('[data-at-reveal], .at-brand-campaign-copy, .rf-products h2, .rf-story-copy');
      nodes.forEach(node => {
        // Content stays visible unless its reveal is actually running.
        ScrollTrigger.create({trigger: node, start: 'top 92%', once: true,
          onEnter: () => gsap.fromTo(node, {y: distance, opacity: 0}, {
            y: 0, opacity: 1, duration: .65, ease: 'power2.out', clearProps: 'transform,opacity'
          })
        });
      });
      if (context.conditions.desktop) {
        document.querySelectorAll('.at-brand-campaign-photo > img').forEach(photo => {
          gsap.fromTo(photo, {scale: 1.025}, {scale: 1, ease: 'none',
            scrollTrigger: {trigger: photo.closest('.at-brand-campaign'), start: 'top bottom', end: 'bottom top', scrub: .8}
          });
        });
      }
    });
    ScrollTrigger.refresh();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {media?.revert();requestAnimationFrame(init);});
  window.addEventListener('load', () => {syncHeader();window.ScrollTrigger?.refresh();}, {once: true});
  document.fonts?.ready.then(() => {syncHeader();window.ScrollTrigger?.refresh();});
})();


